import { useState, useEffect } from 'react'
import adminFetch from './adminFetch'


// One shared helper now: see admin/adminFetch for why three copies of this
// was the bug, not just duplication.
const apiFetch = adminFetch

function fmt(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

const STATUS_COLOR = {
  success: '#34c97e', warning: '#f5a623', error: '#f25d5d', info: '#4f8ef7',
}

export default function AdminShopDetail({ shop, token, onClose, onImpersonate }) {
  const [detail,  setDetail]  = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiFetch(`/shops/${shop.id}`, token)
      .then(d => setDetail(d))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [shop.id])

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 300,
      }}/>

      {/* Panel */}
      <div style={{
        position: 'fixed', right: 0, top: 0, bottom: 0, width: 500,
        background: '#111827', borderLeft: '1px solid #1f2937',
        zIndex: 301, display: 'flex', flexDirection: 'column',
        boxShadow: '-8px 0 40px rgba(0,0,0,0.5)',
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px', borderBottom: '1px solid #1f2937',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
        }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 2 }}>{shop.shopify_domain}</div>
            <div style={{ fontSize: 11, color: '#6b7280' }}>
              {shop.is_active ? '🟢 Active' : '⚫ Uninstalled'}
              {shop.plan_name && ` · ${shop.plan_name} plan`}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onImpersonate} style={{
              background: 'linear-gradient(135deg, #0064d2, #e53238)', border: 'none',
              borderRadius: 8, color: '#fff', padding: '8px 14px',
              fontSize: 12, fontWeight: 700, cursor: 'pointer',
            }}>
              👁 Open Portal
            </button>
            <button onClick={onClose} style={{
              background: '#1f2937', border: '1px solid #374151',
              borderRadius: 8, color: '#9ca3af', padding: '8px 12px',
              fontSize: 14, cursor: 'pointer',
            }}>✕</button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', color: '#4b5563', paddingTop: 60 }}>Loading…</div>
          ) : detail ? <>

            {/* Info grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
              {[
                { label: 'Installed', value: fmt(detail.shop?.installed_at) },
                { label: 'Uninstalled', value: detail.shop?.uninstalled_at ? fmt(detail.shop.uninstalled_at) : '—' },
                { label: 'eBay Shop', value: detail.shop?.ebay_shop_name || '—' },
                { label: 'eBay Connected', value: detail.shop?.ebay_connected_at ? fmt(detail.shop.ebay_connected_at) : '—' },
                { label: 'Last Shopify Sync', value: detail.shop?.last_shopify_sync ? fmt(detail.shop.last_shopify_sync) : '—' },
                { label: 'Last eBay Sync', value: detail.shop?.last_ebay_sync ? fmt(detail.shop.last_ebay_sync) : '—' },
                { label: 'Plan', value: detail.shop?.plan_name ? `${detail.shop.plan_name} ($${detail.shop.plan_price}/${detail.shop.billing_interval})` : 'None' },
                { label: 'Charge Status', value: detail.shop?.charge_status || '—' },
                { label: 'Trial Ends', value: detail.shop?.trial_ends_at ? fmt(detail.shop.trial_ends_at) : '—' },
                { label: 'API Version', value: detail.shop?.shopify_api_version || '—' },
              ].map(row => (
                <div key={row.label} style={{
                  background: '#0d1117', borderRadius: 10, padding: '12px 14px',
                  border: '1px solid #1f2937',
                }}>
                  <div style={{ fontSize: 10, color: '#4b5563', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 4 }}>{row.label}</div>
                  <div style={{ fontSize: 12, color: '#d1d5db', wordBreak: 'break-all' }}>{row.value}</div>
                </div>
              ))}
            </div>

            {/* Sync runs */}
            {detail.recentRuns?.length > 0 && <>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#4b5563', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 10 }}>
                Recent sync runs
              </div>
              <div style={{ marginBottom: 20 }}>
                {detail.recentRuns.map(run => (
                  <div key={run.id} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '9px 12px', background: '#0d1117', borderRadius: 8,
                    border: '1px solid #1f2937', marginBottom: 6,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{
                        fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 4,
                        background: run.status === 'completed' ? 'rgba(52,201,126,0.1)' : run.status === 'failed' ? 'rgba(242,93,93,0.1)' : 'rgba(79,142,247,0.1)',
                        color: run.status === 'completed' ? '#34c97e' : run.status === 'failed' ? '#f25d5d' : '#4f8ef7',
                      }}>{run.status}</span>
                      <span style={{ fontSize: 11, color: '#6b7280', textTransform: 'capitalize' }}>{run.type}</span>
                    </div>
                    <span style={{ fontSize: 11, color: '#4b5563' }}>{fmt(run.started_at)}</span>
                  </div>
                ))}
              </div>
            </>}

            {/* Activity log */}
            {detail.recentLogs?.length > 0 && <>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#4b5563', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 10 }}>
                Recent activity
              </div>
              <div>
                {detail.recentLogs.map(log => (
                  <div key={log.id} style={{
                    padding: '9px 12px', background: '#0d1117', borderRadius: 8,
                    border: '1px solid #1f2937', marginBottom: 6,
                    borderLeft: `3px solid ${STATUS_COLOR[log.status] || '#374151'}`,
                  }}>
                    <div style={{ fontSize: 12, color: '#d1d5db', marginBottom: 3 }}>{log.message}</div>
                    <div style={{ fontSize: 11, color: '#4b5563' }}>{fmt(log.created_at)}</div>
                  </div>
                ))}
              </div>
            </>}

          </> : (
            <div style={{ textAlign: 'center', color: '#4b5563', paddingTop: 60 }}>Failed to load shop details</div>
          )}
        </div>
      </div>
    </>
  )
}
